<!-- Desktop nav -->
<h2 *ngIf="loggedIn">User</h2>
<button mat-menu-item
  *ngIf="loggedIn"
  routerLink="/profile"
  (click)="close.emit()">Profile</button>
<div class="break"></div>
<h2 *ngIf="admin">Administrator</h2>
<button *ngIf="admin"
  mat-menu-item
  (click)="close.emit()"
  routerLink="/admin">Administration</button>
<div class="break"></div>
<h2 *ngIf="organisations.length">Organisations</h2>
<button *ngFor="let organisation of organisations"
  (click)="close.emit()"
  mat-menu-item
  routerLink="organisations/{{organisation.id}}">{{ organisation.name }}</button>
<div class="break"></div>
<h2 *ngIf="loggedIn">Account</h2>
<button mat-menu-item
  class="logout"
  *ngIf="loggedIn"
  (click)="doLogout($event)">Log Out</button>